import {
    _getStartStyle,
    _getElStyle,
    _getInputElStyle,
    goClearInputIcon,
    _getErrorElStyle,
    getInputWid, _showClearIcon, _hideClearIcon
} from "./Common_Fun";

import CalendarUtils from "../../../jsCom/goForm/components/go-calendar-event";


let DateCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else if (formType === "query") {
            return this.getQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (
        {label, id, required, editorType, inputWidth},
        targetObj
    ) {
        return `<div class="row  go-form-row flex-div">
                <div class="go-label" style="${_getElStyle(targetObj)}"><span ${_getStartStyle({required}, targetObj)} class="start-require">*</span>${label}：</div>  
                     <div class="go-content clearfix ${getInputWid(inputWidth)}">
                         <div class="input-group date_input_group pull-left" style="cursor: pointer;${_getInputElStyle(targetObj)}">
                             <input  editorType="${editorType}" ctl="auto"  id="${targetObj.prefixCls}_${id}" readonly="true" type="text" placeholder="${'选择时间'}" class="go-ctl-date form-control">
                                 ${goClearInputIcon(targetObj, id,"",40)} 
                                <i onmouseover="_showErrorToolTip(this,'${id}')" onmouseleave="_hideErrorToolTip(this,'${id}')" style="${_getErrorElStyle(targetObj, 6)}" class="fas fa-exclamation-triangle error-info"></i>
                             <span class="input-group-addon"><i  id="${targetObj.prefixCls}_${id}_img" class="ivu-icon ivu-icon-ios-calendar-outline"></i></span>  
                         </div> 
                    </div>
                </div>`;
    },
    //单条件查询
    getSingleQueryHtml: function ({label, id, editorType}, targetObj) {
        let inputId = `${targetObj.prefixCls}_${id}`;
        return `<div class="go-content clearfix">
                         <div class="input-group date_input_group pull-left" style="cursor: pointer;width:100px;margin-right:4px;">
                             <input onclick="window.setSens('${inputId}_end', 'max','${inputId}');"  style="border: none;height:22px;" ctl="auto" 
                             editorType="${editorType}"  id="${targetObj.prefixCls}_${id}_start" inputId="${inputId}" style="border-right: 0" type="text" placeholder="${'选择开始日期'}" class="go-ctl-date-rang form-control">
                             <span style="border: none;background-color: #FFF" class="input-group-addon"><i style="color:#4A5064" class="ivu-icon ivu-icon-ios-calendar-outline"></i></span>
                         </div> 
                         <div class="input-group date_input_group  pull-left" style="cursor: pointer;width:100px;">
                             <input onclick="window.setSens('${inputId}_start', 'min','${inputId}');"  style="border: none;height:22px;"  ctl="auto" 
                             editorType="${editorType}"  id="${targetObj.prefixCls}_${id}_end" type="text" placeholder="${'选择结束日期'}" class="go-ctl-date-rang form-control">
                             <span style="border: none;background-color: #FFF" class="input-group-addon"><i style="color:#4A5064" class="ivu-icon ivu-icon-ios-calendar-outline"></i></span>
                         </div>
                    </div>`;
    },
    //多条件查询
    getQueryHtml: function (
        {label, id, editorType, inputWidth},
        targetObj
    ) {
        let inputId = `${targetObj.prefixCls}_${id}`;
        return `<div class="row  go-form-row flex-div">
                <div class="go-label" style="${_getElStyle(targetObj)}">${label}：</div>   
                     <div class="go-content clearfix ${getInputWid(inputWidth)}" style="${_getInputElStyle(targetObj)}">
                         <div class="input-group date_input_group pull-left" style="cursor: pointer;width:49%;margin-right:4px;">
                             <input onclick="window.setSens('${inputId}_end', 'max','${inputId}');" ctl="auto" 
                             editorType="${editorType}"  id="${inputId}_start" inputId="${inputId}" type="text" placeholder="${'选择开始日期'}" class="go-ctl-date-rang form-control">
                             <span class="input-group-addon"><i style="color:#4A5064" class="ivu-icon ivu-icon-ios-calendar-outline"></i></span>
                         </div>
                         <div class="input-group date_input_group  pull-left" style="cursor: pointer;width:49%;">
                             <input onclick="window.setSens('${inputId}_start', 'min','${inputId}');" ctl="auto" 
                             editorType="${editorType}"  id="${inputId}_end" type="text" placeholder="${'选择结束日期'}" class="form-control">
                             <span class="input-group-addon"><i style="color:#4A5064" class="ivu-icon ivu-icon-ios-calendar-outline"></i></span>
                         </div>
                    </div>
                </div>`;
    },
    clearData(item, formType, targetObj) {
        //清空数据
        CalendarUtils.clearData(formType, item, targetObj);
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            CalendarUtils.getQuerySubmitData(item, targetObj, backJson);
        } else {
            CalendarUtils.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getRealValue(value) {
        return value || " ";
    },
    initCtlEvent: function (parentObj, inputWidth, targetObj) {
        //初始化日期控件
        $(parentObj)
            .find(".go-ctl-date")
            .each(function () {
                if ($(this).attr("ctl") === "auto") {
                    CalendarUtils.initDateCalendar($(this).attr("id"), $(this).attr("editorType"), targetObj);
                }

                //注册日期图标的事件
                $(this).parent().find(".input-group-addon").click((event)=>{
                    let inputId=$(this).parent().find("input").attr("id");
                    let a=$(this).parent().find("input").get(0);let h=(targetObj.curCtlObj)[inputId];
                    if (!a._dhtmlxcalendar_uid) {
                        return;
                    }
                    if (h.i[a._dhtmlxcalendar_uid].input != null) {
                        h._updateFromInput(h.i[a._dhtmlxcalendar_uid].input);
                    }
                    h._show(a._dhtmlxcalendar_uid, true);
                    event.stopPropagation();
                });
            });

        //如果鼠标移入 当值不为空 则显示清空图标
        $(parentObj).find(".go-ctl-date").each((index,itemObj)=>{
            let inputId = $(itemObj).attr("id");
            $(itemObj).mouseover(function () {
                let elVal = $(`#${inputId}`).val();
                if(elVal!=null&&elVal!==""){
                    _showClearIcon(inputId,parentObj);
                }
            }).mouseleave(function () {
                _hideClearIcon(inputId);
            });
        });

        //初始化时间段控件
        $(parentObj)
            .find(".go-ctl-date-rang")
            .each(function () {
                if ($(this).attr("ctl") === "auto") {
                    CalendarUtils.initDateRang($(this).attr("inputId"));
                }
            });
    }
};


export default DateCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/js-calendar.js